import React from "react";
import { Button, FormControl, FormHelperText, TextField } from "@mui/material";
import styled from "styled-components";
import { onKeyPress } from "../../utils/forms/utils";

const Name = styled.p`
    font-size: ${({ fontSize }) => fontSize || "20"}px;
    font-weight: 600;
    color: ${({ theme, result, defaultColor }) => {
        if (result === "pending") return theme.palette.text.disabled;
        if (result === "success") return theme.palette.success.main;
        if (result === "failure") return theme.palette.error.main;
        return defaultColor || theme.palette.text.secondary;
    }};
    margin: 0;
    cursor: pointer;
`;

const ContainedTextField = ({
    initialValue,
    refetch,
    requestFormatter,
    placeholderText,
    fontSize,
    defaultColor,
}) => {
    const [value, setValue] = React.useState(initialValue);
    const [error, setError] = React.useState();
    const [disabled, setDisabled] = React.useState(false);
    const [onEdit, setOnEdit] = React.useState(false);
    const [editResult, setEditResult] = React.useState();

    React.useEffect(() => {
        if (initialValue || editResult === "failure" || editResult === "success") {
            setValue(initialValue);
            setTimeout(() => setEditResult(undefined), 500);
        }
    }, [initialValue, editResult]);

    const minLengthChecker = (currentValue) => {
        if (currentValue.length < 3) return `Should be a minimum of ${3} characters`;
        return undefined;
    };

    const closeEdit = () => setOnEdit(false);

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const postChanges = async () => {
        setEditResult("pending");
        closeEdit();
        try {
            await requestFormatter(value);
            setEditResult("success");
        } catch (e) {
            setEditResult("failure");
        }
    };

    const handleSubmit = async (event) => {
        const currentValue = event.target.value;
        const currentError = minLengthChecker(currentValue);
        if (currentError) {
            setError(currentError);
        } else {
            setError(null);
            if (initialValue !== value) {
                setDisabled(true);
                await postChanges();
                await refetch();
                setDisabled(false);
            } else {
                closeEdit();
            }
        }
    };

    const handleCancel = () => {
        if (initialValue) setValue(initialValue);
        closeEdit();
    };

    const handleBlur = (event) => {
        if (!event.target.value) return closeEdit();
        return handleSubmit(event);
    };

    if (!onEdit)
        return (
            <Button
                sx={{ textTransform: "none", padding: 0, margin: 0 }}
                onClick={() => {
                    if (!editResult) setOnEdit(true);
                }}
            >
                <Name fontSize={fontSize} defaultColor={defaultColor} result={editResult}>
                    {value || placeholderText}
                </Name>
            </Button>
        );

    return (
        <FormControl error={!!error} fullWidth>
            <TextField
                autoFocus
                size="small"
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyDown={onKeyPress(handleSubmit, handleCancel)}
                variant="standard"
                disabled={disabled}
            />
            <FormHelperText error>{error}</FormHelperText>
        </FormControl>
    );
};

export default ContainedTextField;
